import { ChecklistActions } from "../action-types/checklistActionTypes";

const initialState = {
  checklistData: [],
  checklisQuestiontAnswerData: [],
  checklisDefectsData: [],
  checklistPaginationData: [],
};

const checklistReducer = (state = initialState, action) => {
  switch (action.type) {
    case ChecklistActions.SET_CHECKLIST_LIST:
      console.warn("SET_CHECKLIST_LIST", action.payload);
      return {
        ...state,
        checklistData: action.payload,
      };
    case ChecklistActions.SET_CHECKLIST_LIST_PAGINATION:
      console.warn("SET_CHECKLIST_LIST_PAGINATION", action.payload);
      return {
        ...state,
        checklistPaginationData: action.payload,
      };
    case ChecklistActions.SET_CHECKLIST_QUESTION_ANSWER_LIST:
      console.warn("SET_CHECKLIST_QUESTION_ANSWER_LIST", action.payload);
      return {
        ...state,
        checklisQuestiontAnswerData: action.payload,
      };
    case ChecklistActions.SET_CHECKLIST_DEFECTS_LIST:
      console.warn("SET_CHECKLIST_QUESTION_ANSWER_LIST", action.payload);
      return {
        ...state,
        checklisDefectsData: action.payload,
      };
    default:
      return state;
  }
};

export default checklistReducer;
